// ✅ ProgressBar.jsx — Compact Minimal Mortgage Matrix Version
import React from "react";
import styles from "./RefinanceForm.module.css";

function ProgressBar({ step, totalSteps, stepLabels }) {
  const percent = Math.round((step / totalSteps) * 100);
  const currentLabel = stepLabels?.[step - 1] || "";

  return (
    <div className={styles.progressBarWrapper}>
      {/* === Top thin bar === */}
      <div className={styles.progressTopTrack}>
        <div
          className={styles.progressTopFill}
          style={{ width: `${percent}%` }}
        />
      </div>

      {/* === Step counter + title === */}
      <div className={styles.progressHeaderRow}>
        <span className={styles.progressCounter}>
          Step {step} of {totalSteps}: <strong>{currentLabel}</strong>
        </span>
      </div>
    </div>
  );
}

export default ProgressBar;
